export type ModerationAction = 'allow' | 'flag' | 'block';

export type ModerationFieldType =
  | 'username'
  | 'profile_bio'
  | 'tournament_name'
  | 'tournament_description'
  | 'tournament_rules'
  | 'league_name'
  | 'league_description'
  | 'team_name'
  | 'team_description'
  | 'participant_name'
  | 'post_content'
  | 'post_image'
  | 'avatar_image'
  | 'challenge_message';

export interface ModerationDecision {
  action: ModerationAction;
  reasons: string[];
}

export class ModerationError extends Error {
  constructor(public reasons: string[]) {
    super('Content blocked by moderation');
    this.name = 'ModerationError';
  }
}
